import React, { memo } from "react";
import { StyleSheet, View } from "react-native";
import Text from "@components/CustomText";
import color from "@constants/color";

interface HistoryStatTileProps {
  value: number;
  label: string;
}

const HistoryStatTile: React.FC<HistoryStatTileProps> = ({ value, label }) => (
  <View style={styles.tile}>
    <Text variant="heading_24" style={styles.value}>
      {value}
    </Text>
    <Text variant="caption_2" style={styles.label} numberOfLines={2}>
      {label}
    </Text>
  </View>
);

export default memo(HistoryStatTile);

const styles = StyleSheet.create({
  tile: {
    flex: 1,
    alignItems: "center",
    paddingVertical: 12,
    borderRadius: 12,
    backgroundColor: color.lightGray,
  },
  value: {
    color: color.mediumBlack,
  },
  label: {
    color: color.lightMediumBlack,
    textAlign: "center",
    marginTop: 4,
  },
});
